import { Monitor, Smartphone } from "lucide-react";

const KEY = "xaltix_desktop_view";
const PHONE = () => Math.min(window.screen?.width || 9999, window.screen?.height || 9999) < 768;

export const applyViewMode = () => {
  const m = document.querySelector('meta[name="viewport"]');
  if (!m) return;
  const desk = PHONE() && localStorage.getItem(KEY) === "1";
  m.setAttribute("content", desk ? "width=1280" : "width=device-width, initial-scale=1");
  document.documentElement.classList.toggle("desktop-on-phone", desk);
};

export const ViewModeToggle = () => {
  if (!PHONE()) return null;
  const desk = localStorage.getItem(KEY) === "1";
  const flip = () => { localStorage.setItem(KEY, desk ? "0" : "1"); applyViewMode(); window.location.reload(); };
  return (
    <button type="button" onClick={flip} data-testid="view-mode-toggle" title={desk ? "Revenir à l'affichage mobile" : "Passer en version ordinateur"}
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 px-2.5 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 shrink-0">
      {desk ? <Smartphone className="h-3.5 w-3.5" /> : <Monitor className="h-3.5 w-3.5" />}
      <span>{desk ? "Mobile" : "Ordinateur"}</span>
    </button>
  );
};
